import { FETCH_CONTACTS_SUCCESS } from '../types'

export default function reduceLatestLoadedRequestKey(state = null, action) {
  const { type, meta: { requestParameters: { filter } = {} } = {} } = action
  if (type === FETCH_CONTACTS_SUCCESS) {
    const { search } = filter || {}
    return search || null
  }
  return state
}
